module.exports = __webpack_public_path__ + "static/top_process_bg-edcc10a5a57ed20422c19407a7a47262.png";